import { render, staticRenderFns } from "./DatagramsDebugList.vue?vue&type=template&id=4a16d7c1&scoped=true"
import script from "./DatagramsDebugList.vue?vue&type=script&lang=js"
export * from "./DatagramsDebugList.vue?vue&type=script&lang=js"
import style0 from "./DatagramsDebugList.vue?vue&type=style&index=0&id=4a16d7c1&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a16d7c1",
  null
  
)

export default component.exports